export default "/images/banali-avatar.svg?a4ca255bc55744794ec2d5d2d03fcac9";